
// ModalEditarItensCompra.js

import React, { useState, useEffect } from 'react';
//import Axios from 'axios';
import api from '../config/axiosConfig';

import './ModalEditarItens.css';

function ModalEditarItensCompra({ isOpen, fecharModal, codCompra, dtcompra, codemp, codfor, onSave }) {
  const [materiais, setMateriais] = useState([]);
  const [itensCompra, setItensCompra] = useState([]);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [quantidade, setQuantidade] = useState(1);
  const [valunit, setValunit] = useState(0.0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      console.log(`Modal opened for compra: ${codCompra}`);

      setItensCompra([]);

      api.get('/materiais/listarmateriais')

        .then(response => {
          setMateriais(response.data);
        })
        .catch(error => {
          console.error('Erro ao buscar materiais:', error);
        });

      api.get(`/comprasitem/${codCompra}/itens`)

        .then(response => {
          console.log(`Itens da compra ${codCompra}:`, response.data);
          setItensCompra(response.data);
        })
        .catch(error => {
          console.error('Erro ao buscar itens da compra:', error);
        });
    }
  }, [isOpen, codCompra]);

const handleAddItem = () => {
  console.log("Tentando adicionar item:", { selectedMaterial, quantidade, valunit });
  if (selectedMaterial && quantidade > 0 && valunit > 0) {
    const novoItem = {
      codpro: selectedMaterial.id,
      material: selectedMaterial.material,
      quantidade,
      valunit,
      valitem: quantidade * valunit,
      codemp: codemp,   
      codfor: codfor,   
      codCompra: codCompra, 
      dtcompra: dtcompra 
    };
    console.log("Novo item a ser adicionado:", novoItem);
    setItensCompra([...itensCompra, novoItem]);
    setSelectedMaterial(null);
    setQuantidade(1);
    setValunit(0.0);
  } else {
    console.warn("Dados insuficientes para adicionar o item.");
  }
  };
  

  const handleRemoveItem = (index) => {
    const itemToRemove = itensCompra[index];
    if (itemToRemove.id) {
      api.delete(`/comprasitem/compraitem/${itemToRemove.id}`)

        .then(() => {
          const novosItens = itensCompra.filter((_, i) => i !== index);
          setItensCompra(novosItens);
        })
        .catch(error => {
          console.error('Erro ao remover item da compra:', error);
        });
    } else {
      const novosItens = itensCompra.filter((_, i) => i !== index);
      setItensCompra(novosItens);
    }
  };

  const handleSave = () => {
    setLoading(true);
    const valorTotal = itensCompra.reduce((total, item) => total + item.valitem, 0);

    api.post(`/comprasitem/${codCompra}/itens`, itensCompra)

      .then(() => {
        return api.put(`/comprasitem/${codCompra}/valor`, valorTotal);
      })
      .then(() => {
        onSave();
      })
      .catch(error => {
        console.error('Erro ao salvar itens da compra:', error);
      })
      .finally(() => {
        setLoading(false);
        fecharModal();
      });
  };

  const handleCloseModal = () => {
    setItensCompra([]);
    fecharModal();
  };


// Função para lidar com a mudança do valor no input e formatar o valor
const handleValorChange = (index, field, value) => {
  const updatedItensCompra = [...itensCompra];
  if (field === 'valunit' || field === 'valitem') {
    // Remove caracteres não numéricos, exceto ponto (.) e vírgula (,)
    let numericValue = value.replace(/[^0-9,]/g, '').replace(',', '.');
    numericValue = parseFloat(numericValue);

    updatedItensCompra[index][field] = numericValue;
  } else {
    updatedItensCompra[index][field] = value;
  }
  setItensCompra(updatedItensCompra);
};

// Função para formatar valores para o formato de moeda BRL
const formatarValorInput = (valor) => {
  if (!valor) return 'R$ 0,00';
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
};


  if (!isOpen) return null;

  return (
    <div className="modal">
      <div className="modal-content">
        <span className="close" onClick={handleCloseModal}>&times;</span>

        
<h3>Editando Itens da Compra: {codCompra}</h3>
        

<div className="input-group">
  <div className="input-container">
    <label htmlFor="material-select">Selecione um material</label>
<select
  id="material-select"
  onChange={(e) => {
    const value = e.target.value;
    setSelectedMaterial(value ? JSON.parse(value) : null);
  }}
  value={selectedMaterial ? JSON.stringify(selectedMaterial) : ''}
>
  <option value="">-- Selecionar --</option>
  {materiais.map(material => (
    <option key={material.id} value={JSON.stringify(material)}>
      {material.material}
    </option>
  ))}
</select>
</div>

  <div className="input-container">
    <label htmlFor="quantidade-input">Quantidade</label>
    <input
      id="quantidade-input"
      type="number"
      value={quantidade}
      onChange={(e) => setQuantidade(parseInt(e.target.value, 10))}
      min="1"
      className="input-quantidade"
    />
  </div>

  <div className="input-container">
    <label htmlFor="valunit-input">Valor Unitário</label>
    <input
      id="valunit-input"
      type="text"
      value={formatarValorInput(valunit)}
      onChange={(e) => {
        const formattedValue = e.target.value.replace(/\D/g, ''); // Remove caracteres não numéricos
        setValunit(parseFloat(formattedValue) / 100); // Converte para float
      }}
      className="input-valunit"
    />
  </div>

  <div className="input-container">
          <button className="botao-adicionar" onClick={handleAddItem}>Adicionar</button>
  </div>

        
</div>
        

  <table className="table-itensvenda">
             <colgroup>
                 <col className="coluna-material" />
                 <col className="coluna-quantidade" />
                 <col className="coluna-valunit" />
                 <col className="coluna-valitem" />
                <col className="coluna-acoes" />
            </colgroup>
            <thead>
                <tr>
                 <th>Material</th>
                 <th>Quantidade</th>
                 <th translate="no">Valor Unitário</th>
                 <th translate="no">Valor Item</th>
                 <th>Ações</th>
               </tr>
             </thead>
              <tbody>
                 {itensCompra && itensCompra.map((item, index) => (
                  <tr key={index}>
                    <td title={item.material} className="btn-truncate">{item.material}</td>
                    <td>{item.quantidade}</td>
                    <td>
                    <input
                      type="text"
                      value={formatarValorInput(item.valunit)}
                      onChange={(e) => handleValorChange(index, 'valunit', e.target.value)}
                      className="input-valunit"
                    />
                    </td>
                    <td>
                    <input
                      type="text"
                      value={formatarValorInput(item.valitem)}
                      onChange={(e) => handleValorChange(index, 'valitem', e.target.value)}
                      className="input-valitem"
                    />
                    </td>
                    <td>
                      <button className="button" onClick={() => handleRemoveItem(index)} translate="no">Remover</button>
                    </td>
                 </tr>
              ))}
             </tbody>
        </table>

        <div className="button-container">
          <button className="salvar" onClick={handleSave} disabled={loading}>{loading ? 'Salvando...' : 'Salvar'}</button>
        </div>
      </div>
    </div>
  );
}

export default ModalEditarItensCompra;
